
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DraggableItem from '@/components/busi/custom/draggableitem.vue'
import Draggable from 'vuedraggable'
import { Option, Warning } from './option'

@Component({
  name: 'detail',
  components: {
    Draggable,
    'draggable-item': DraggableItem
  }
})

export default class Detail extends Vue {
  @Prop({ type: Array })
  private data!: any[]

  @Prop({ type: String })
  private flag!: string

  private dataSync = this.deepClone(this.data)

  private draggable = !1

  private change (val: any) {
    if (val) {
      this.options.draggable = '.darggable-item'
    } else {
      this.options.draggable = ''
    }
  }

  private options = {
    draggable: ''
  }

  private tmpl = '1'

  private list = [{
    title_type: 'chapter_title',
    title: '',
    subtitle: '',
    content: '',
    school_id: '1',
    images: []
  },
  {
    title_type: 'school_profile',
    title: '',
    subtitle: '',
    content: '',
    school_id: '2',
    images: []
  },
  {
    title_type: 'quality_resources',
    title: '',
    subtitle: '',
    content: '',
    school_id: '2',
    images: []
  },
  {
    title_type: 'training_mode',
    title: '',
    subtitle: '',
    content: '',
    school_id: '2',
    images: []
  },
  {
    title_type: 'employment_recommendation',
    title: '',
    subtitle: '',
    content: '',
    school_id: '2',
    images: []
  },
  {
    title_type: 'professiomal_curriculum',
    title: '',
    subtitle: '',
    content: '',
    school_id: '2',
    images: []
  },
  {
    title_type: 'place_of_study',
    title: '',
    subtitle: '',
    content: '',
    school_id: '2',
    images: []
  },
  {
    title_type: 'campus_scenery',
    title: '',
    subtitle: '',
    content: '',
    school_id: '2',
    images: []
  },
  {
    title_type: 'registration_matters',
    title: '',
    subtitle: '',
    content: '',
    school_id: '2',
    images: []
  }]

  private option = Option

  private warning = Warning

  @Watch('dataSync')
  private dataSyncChange (val: any) {
    const temp = this.deepClone(this.data)
    for (let i = 0; i < val.length; i++) {
      this.copyDeep(i, val[i].titleType, [...temp])
    }
  }

  private copyDeep (index: any, titleType: any, temp: any) {
    let target: any = {}
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].titleType === titleType) {
        target = { ...temp[i] }
        target.seq = index + 1
      }
    }
    const item = this.data[index]
    for (const key in item) {
      this.data[index][key] = target[key]
    }
  }

  private deepClone (target: any) {
    // 定义一个变量
    let result: any
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
    // 如果是一个数组的话
      if (Array.isArray(target)) {
        result = [] // 将result赋值为一个数组，并且执行遍历
        for (const i in target) {
          // 递归克隆数组中的每一项
          result.push(this.deepClone(target[i]))
        }
        // 判断如果当前的值是null的话；直接赋值为null
      } else if (target === null) {
        result = null
        // 判断如果当前的值是一个RegExp对象的话，直接赋值
      } else if (target.constructor === RegExp) {
        result = target
      } else {
        // 否则是普通对象，直接for in循环，递归赋值对象的所有值
        result = {}
        for (const i in target) {
          result[i] = this.deepClone(target[i])
        }
      }
      // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
      result = target
    }
    // 返回最终结果
    return result
  }
}
